<template>
	<div class="foot-fix pos-r">
		<div id="bg-steps" class="bg-black">
			<div v-show="$route.fullPath.toUpperCase().includes('/BLD#!/?draft=')" class="header">
				<div class="container nzxtcustom-container">
					<div class="row">
						<div v-show="false" class="mobile-only-menu">
							<a class="mobile-menu" href="/">
								<img
									class="img-responsive copyright-logo"
									src="/assets/logo-bld.png"
									alt="Logo white"
								>
							</a>
						</div>
						<div class="overview-buy" style="display: none;">
							<a
								class="overview"
								href="#"
								style="display: none; float: none;"
							>
								OVERVIEW
							</a>
						</div>
						<div class="share-save" style="opacity: 0; display: inline-block;">
							<a class="save" href="#">SAVE</a>
							<a class="share" href="#">SHARE</a>
						</div>
						<div class="overview-buy with-checkout pull-right" style="display: none;">
							<div class="affirm pull-left">
								<div id="wrapLearnMore" style="display: block;">
									<a id="learn-more" style="visibility: visible;">
										PAY AS LOW AS $86 /MONTH
										<div class="affirm-text">
											FINANCE YOUR PURCHASE THROUGH
											<span class="affirm-logo"/>
										</div>
									</a>
								</div>
							</div>
							<a class="buy-me2" style="display: none;">CHECKOUT</a>
							<div class="price">$974.91</div>
						</div>
					</div>
				</div>
			</div>

			<div class="container nzxtcustom2">
				<div class="title-container">
					<h1 class="step1__heading">
						What do you plan to play?
					</h1>
					<h4 class="step1__subtitle">
						Select up to 3 games
					</h4>
				</div>
				<!-- step-1-games -->
				<div class="row">
					<div class="games-selection">
						<div class="six-cols p-y-md">
							<div class="container">
								<template v-if="games.length">
									<template v-for="list in gameChunks">
										<template v-for="(game, index) in list">
											<div
												:key="'game-' + game.id"
												:id="'game-' + game.id"
												:class="'cover_' + game.id"
												class="game-cover pull-left pos-r text-center pointer"
												@click.prevent="($event) => addSelectedGame(game, index, $event)"
											>
												<a
													:id="'game-' + index"
													:data-original-title="game.name"
													:title="game.name"
													:class="getImageClass(game, 'v-game','disabled-link v-game')"
													data-html="true"
													data-toggle="tooltip"
													data-placement="bottom"
												>
													<img
														:src="game.image_url"
														:data-ref="game.id"
														:class="getImageClass(game, 'game_no_selected', 'not-rs game_no_selected')"
													>
												</a>
											</div>
										</template>
									</template>
								</template>
								<template v-else>
									<div class="row">
										<div class="col-md-12 loading-games">
											<p>LOADING GAMES</p>
										</div>
									</div>
								</template>
								<!-- selection next step btn and warning -->
							</div>
						</div>
						<div v-show="games.length" class="container buttons-container">
							<!-- 1080/1440 switchery-sendgames -->
							<div class="row buttons-row pick-your-price">
								<!-- switchery -->
								<div class="resolution-switch__container col-xs-12 col-sm-3">
									<div class="resolution-switch">
										<general-switch
											v-model="resolutionFilter"
											first-option="1080"
											second-option="1440"
											jack-color="#51007A"
											jack-secondary-color="#51007A"
											@input="toggleChange"
										/>
									</div>
									<img
										src="images/icons/question-help.svg"
										alt="Screen resolution tooltip"
										class="hidden-md hidden-lg"
										@click="showResolutionDrawer = true"
									>
								</div>
								<!-- /.switchery -->
								<!-- send-games -->
								<suggested-games v-if="!POS_MODE"/>
								<div v-else class="hidden-xs col-xs-12 col-sm-6 text-center"/>
								<!-- /.send-games -->
								<div class="col-xs-12 col-sm-4 aling-btn">
									<div class="select-warning m-t-md m-b-lg game-submit">
										<!-- next step btn -->
										<span
											v-show="selectedGames.length <= gameLimit"
											class="link"
										>
											<a
												id="link-step2"
												class="btn btn-block btn-green btn-outline disable-mobile"
												href="#"
												@click.prevent="(e) => !isMobile() ? gotoStep2() : null"
												@touchstart="(e) => isMobile() ? gotoStep2() : null"
											>
												PICK YOUR PRICE
											</a>
										</span>
										<span
											v-show="selectedGames.length > gameLimit"
											class="link2"
										>
											<a
												class="btn btn-block too-many"
											>
												<span
													class="content-text"
												>OOPS, {{ selectedGames.length - gameLimit }} TOO MANY</span>
											</a>
										</span>
									</div>
								</div>
								<!-- /.nextstep-and-warning -->
							</div>
							<!-- /.1080/1440 switchery-sendgames -->
						</div>
						<div class="clearfix"/>
					</div>
					<!-- select-intro -->
					<div class="select-intro intro2" style="display:none;">
						<div class="select-content">
							<div class="title">
								<h1 class="text-center text-cgrey">SELECT YOUR GAMES</h1>
							</div>
						</div>
					</div>
					<!-- /.select-intro -->
				</div>
			</div>
			<!-- /.step-1-games -->
		</div>
		<!-- BLD-OVERLAYS -->
		<div class="loading" style="display: none;">
			<p class="text-center">CALCULATING</p>
		</div>
		<div class="share-overlay text-center" style="display: none;">
			<a class="close-overlay close text-white text-light" href="#" rel="share-overlay">
				<img src="/assets/close-overlay.png" alt="Close overlay">
			</a>
			<div class="panel-user" style="display: block;">
				<h2 class="text-center">SHARE</h2>
				<div class="row">
					<div class="col-md-12">
						<div class="text">
							<p>USE THE LINK BELOW TO SHARE YOUR BUILD</p>
						</div>
						<div class="link m-b"/>
						<div class="social-content social-icons text-center m-t">
							<a id="sharenzxt-facebook" href="#" target="_blank">
								<i class="fa fa-facebook-square"/>
							</a>
							<a id="sharenzxt-twitter" href="#" target="_blank">
								<i class="fa fa-twitter"/>
							</a>
							<a id="sharenzxt-google-plus" href="#" target="_blank">
								<i class="fa fa-google-plus"/>
							</a>
							<a href="#" data-dismiss="modal">
								<i class="fa fa-envelope"/>
							</a>
							<a id="sharenzxt-copy-link" href="#" target="_blank">
								<i class="fa fa-link"/>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="save-overlay text-center" style="display: none;">
			<a class="close-overlay close text-white text-light" href="#" rel="save-overlay">
				<img src="/assets/close-overlay.png" alt="Close overlay">
			</a>
			<div class="panel-user" style="display: block;">
				<h2 class="text-center">SHARE YOUR BUILD</h2>
				<div class="row">
					<div class="col-md-12">
						<div class="text">CLICK THE LINK BELOW TO SHARE</div>
						<div class="link m-b"/>
						<div class="or">OR</div>
						<div class="see">
							<a @click="goToSavedBuilds()">SEE ALL YOUR SAVED BUILDS</a>
							<div class="breadcrumb-build">BUILDS &gt; Saved</div>
						</div>
						<div class="social-content social-icons text-center m-t">
							<a href="#" target="_blank">
								<i class="fa fa-facebook-square"/>
							</a>
							<a href="#" target="_blank">
								<i class="fa fa-twitter"/>
							</a>
							<a href="#" target="_blank">
								<i class="fa fa-google-plus"/>
							</a>
							<a href="#" data-dismiss="modal">
								<i class="fa fa-envelope"/>
							</a>
							<a href="#" target="_blank">
								<i class="fa fa-link"/>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="share-overlay-list text-center" style="display: none;">
			<a class="close-overlay text-white text-light" href="#" rel="share-overlay-list">
				<img src="/assets/close-overlay.png" alt="Close overlay">
			</a>
			<h2 class="text-center">SHARE YOUR BUILD</h2>
			<div class="row">
				<div class="col-md-12">
					<div class="link"/>
				</div>
			</div>
		</div>
		<div class="message-overlay text-center" style="display: none;">
			<a class="close-overlay" href="#" rel="message-overlay">
				<img src="/assets/close-overlay.png" alt="Close overlay">
			</a>
			<div class="panel-text"/>
		</div>
		<div class="over-capacity-warning text-center" style="display: none;">
			<a class="close-overlay" href="#" rel="over-capacity-warning">
				<img src="/assets/close-overlay.png" alt="Close overlay">
			</a>
			<h2 class="text-center">Max Capacity Warning</h2>
			<div class="row">
				<div class="col-md-12">
					<div class="text">
						Our builders need to wait on their skill cooldowns so we can't take your order
						right now. We want to make sure they are ready to forge your build so why don't
						you create an account to save it then we can holler when their cooldowns are up?
					</div>
					<a id="queue-build" class="button" href="#">Let me save it!</a>
					<div class="thank-you">Thank you for signing up.</div>
					<div class="thank-you">Please look for an email from us!</div>
					<div class="already-in-queue">You are already in the queue.</div>
					<div
						class="already-in-queue"
					>
						Rest assured that we will contact you when it's your turn to checkout!
					</div>
					<a id="close-warning" class="button" href="#">Not yet!</a>
				</div>
			</div>
		</div>
		<div id="general-overlay" class="overlay" style="display:none;"/>
		<div class="container pos-r">
			<a
				alt="Back"
				class="back-step"
				title="Back"
				data-link="step1"
				style="display: none;"
			>
				<i aria-hidden="true" class="back-step-ico">
					<img src="/images/icons/back-ico.svg" alt width="30">
				</i>
			</a>
		</div>
		<drawer-modal v-model="showResolutionDrawer" class="screen-resolution">
			<p class="screen-resolution__title">We optimize our benchmarks  <br> for two display standards:</p>
			<div class="screen-resolution__img">
				<img src="/images/icons/monitor-screen-resolutions.svg" alt="monitors showing two resolutions 1980x1080 and 2560x1440">
			</div>
		</drawer-modal>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import FastClick from "fastclick";
import suggestedGames from "./suggested-games.vue";
import DrawerModal from "./drawer-modal";
import { gtmTrack } from "@/util/gtm";
import { isMobile } from "@/util/helpers";
import { heapAnalytics } from "@/util/mixins";
import GeneralSwitch from "@c/generals/general-switch";

export default {
	name: "StoreBld",
	components: {
		GeneralSwitch,
		suggestedGames,
		DrawerModal
	},
	mixins: [heapAnalytics],
	data() {
		return {
			managingSelectedGames: false,
			games: [],
			gameChunks: [],
			selectedGames: [],
			gameLimit: 3,
			switchValue: "",
			resolutionFilter: "1080",
			buildIntro: true,
			showScrollOverlay: true,
			showResolutionDrawer: false
		};
	},
	computed: {
		showButton() {
			return this.selectedGames.length <= this.gameLimit;
		}
	},
	watch: {
		selectedGames() {
			if (this.selectedGames.length <= this.gameLimit) {
				$(".border-warning").removeClass("border-warning");
			}
		}
	},
	mounted() {
		FastClick.attach(this.$el);

		const initialScroll = window.scrollY;
		$(window).on("scroll", () => {
			if (initialScroll != window.scrollY) {
				this.showScrollOverlay = false;
			}
		});

		$(window).one("click", () => {
			this.showScrollOverlay = false;
		});
	},
	created() {
		axios({
			url: "/games?q=(is_deleted:0,is_disabled:0)&sort=name|ASC",
			method: "GET",
			responseType: "json"
		}).then(response => {
			this.gameChunks = _.chunk(response.data, 7);
			this.games = response.data.map(game => {
				game.selected = false;
				return game;
			});
		});
		$("body").addClass("bg-black");
		this.setGamesResolution();

		// Heap test.
		heap.track("View Select Games - Client", {
			experiment_id: window.CONFIG.HEAP
		});
	},
	updated() {
		if (!this.managingSelectedGames) {
			$(".intro").css({
				display: "flex"
			});
			this.managingSelectedGames = true;
		}

		if (!window.nzxt_init) {
			window.nzxt_init = true;
		}

		$('[data-toggle="tooltip"]').tooltip();
	},
	methods: {
		...mapActions({
			setResolution: "StarterPc/setResolution"
		}),
		addSelectedGame(game, index, event) {
			const $target = $(event.target);

			if (game.selected) {
				game.selected = false;
				$target.removeClass("game_selected");
				$target.removeClass("border-warning");
				$target.addClass("game_no_selected");
			} else {
				game.selected = true;
				$target.addClass("game_selected");
				$target.removeClass("game_no_selected");

				this.trackAll("Client: Click Game", { Game: game.name });
			}

			this.selectedGames = this.games.filter(game => game.selected);
			if (game.selected && this.selectedGames.length > this.gameLimit) {
				$target.addClass("border-warning");
			}

			this.selectGame();
		},
		selectGame() {
			if (this.selectedGames.length === 0) {
				$(".game-submit a").addClass("disable-mobile");
				!isMobile() && $(".game-submit a").hide();
			} else {
				$(".game-submit a").removeClass("disable-mobile");
				$(".game-submit a").hide();
				if (this.selectedGames.length > this.gameLimit) {
					$(".game-submit a.too-many").css("display", "block");
				} else {
					$(".game-submit a#link-step2").css("display", "block");
				}
			}
		},
		getImageClass(game, defaultClass, newClass) {
			const isDesktop = (this.resolutionFilter == "1080" && Number(game.standard_fps_1080) > 0)
            || (this.resolutionFilter == "1440" && Number(game.standard_fps_1440) > 0);

			let finalClass = isDesktop ? defaultClass : newClass;

			if (isMobile(true)) {
				finalClass += " mobile-selected-img";
			}

			return finalClass;
		},
		searchElementInArray(array, value) {
			for (let i = 0; i <= array.length; i++) {
				if (array[i] == value) {
					return i;
				}
			}
			return -1;
		},
		toggleChange() {
			this.setGamesResolution();
		},
		goToSavedBuilds() {
			// User is logged in
			if (!Cookies.get("cookies_id")) {
				this.$modal.show("login-modal");
				this.$router.push({
					query: Object.assign({}, this.$route.query, {
						redirect: "/user/account?currentTab=saved-build"
					})
				});
			} else {
				this.$router.push({
					name: "UserAccount",
					query: { currentTab: "saved-build" }
				});
			}
		},
		setGamesResolution() {
			this.setResolution(this.resolutionFilter);

			const data = new FormData();
			data.append("session", CONFIG.SESSION);
			data.append("resolution", this.resolutionFilter);

			axios({
				url: "/set-resolution",
				method: "POST",
				data
			});
		},
		gotoStep2() {
			let gameIds = "";
			const selectedGamesNames = [];

			this.trackAll("Client: Click Your Price");
			this.selectedGames.forEach(game => {
				gameIds += `${game.id}|`;
				selectedGamesNames.push(game.name);
			});
			gtmTrack.configuratorGames(selectedGamesNames);

			axios({
				url: `/add-game/${gameIds}`,
				headers: {
					Token: window.CONFIG.SESSION
				}
			}).then(() => {
				this.$router.push("/bld/step2");
			});
		},
		isMobile() {
			return isMobile(true);
		}
	}
};
</script>


<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.title-container {
    margin-bottom: -10px;
}

.pick-your-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 107px;
    @media only screen
    and (min-width: 320px)
    and (max-width: 480px) {
        display: block;
    }
}

.step1__heading,
.step1__subtitle {
    color: white;
    font-family: Akkurat-Normal;
    margin-left: 23px;
}

.step1__heading {
    font-weight: bold;
}

.step1__heading {
    padding-top: 20px;

    font-size: 24px;
    font-weight: 600;

    text-transform: uppercase;
}

.step1__subtitle {
    font-size: 16px
}

.screen-resolution {
    &__title {
        text-align: center;
        font-size: 16px;
    }
    &__img {
        padding: 20px 0;
        text-align: center;
    }
}

@media (max-width: 991px) {
    .title-container {
        margin-bottom: 0;
    }

    .step1__heading {
        color: #FFFFFF;
        font-family: Akkurat-Normal;
        font-size: 24px;
        text-align: center;
        margin-top: 0;
        margin-bottom: 5px;
        margin-top: 25px;
        margin-left: 0;
        font-weight: normal;
        text-transform: none;
        padding-top: 0;
        font-weight: bold;
    }

    .step1__subtitle {
        color: #FFFFFF;
        font-size: 16px;
        text-align: center;
        margin: 0;
        font-weight: 600;
        font-weight: normal;
    }

    .step1__heading,
    .step1__subtitle {
        display: block;
    }

    .six-cols {
        padding-bottom: 200px;

        .container {
            overflow: hidden;
        }
    }

    .buttons-container {
        background-color: #1A1A1A;
        z-index: 99999;
        position: fixed;
        bottom: 0;
        width: 100%;

        .resolution-switch__container {
            display: flex;
            justify-content: center;
            margin-bottom: 15px;
            position: relative;

            .resolution-switch {
                margin: 25px auto 0;
            }

            img {
                position: absolute;
                bottom: 0;
                right: 15px;
            }
        }

        .game-submit {
            height: auto;
            margin-bottom: 25px;

            a {
                padding: 15px;
                color: #fff;
                letter-spacing: 1.34px;
                font-size: 14px;
                border: none;
                border-radius: 2px;
                transition: none;
                display: flex !important;
                justify-content: center;
                align-items: center;
                height: 50px;

                &:hover {
                    border: none;
                    color: #fff;
                }
            }

             a#link-step2 {
                background-color: $oldpurple;
                @media (min-width: 768px) {
                    background: transparent !important;
                    border: 4px solid $oldpurple;
                    color: $oldpurple;
                }
            }

            a#link-step2.disable-mobile {
                opacity: 0.5;
                pointer-events: none;
                background-color: $oldpurple;

            }

            a.too-many {
                background-color: #D0021B;
            }
        }
    }
}

.buttons-row {
    padding-left: 25px;
    padding-right: 50px;

    @media (max-width: 1024px) {
        padding-right: 45px;
    }

    @media (max-width: 768px) {
        padding: 0;
    }
}

@media (min-width: 1281px) {
  .container.buttons-container {
      margin-top: -78px;
  }
}

@media only screen
and (min-device-width : 768px)
and (max-device-width : 1024px)
and (orientation : landscape) {
    .aling-btn {
        left: -17px;
    }
}

@media only screen
and (min-device-width : 768px)
and (max-device-width : 1024px) {
    .buttons-container {
        margin-top: -78px;
    }
}

@media only screen
and (min-device-width : 768px)
and (max-device-width : 1024px)
and (orientation : portrait) {
    .buttons-container {
        margin-bottom: 50px;
    }
}

@media only screen
  and (min-width: 1024px)
  and (max-height: 1366px)
  and (orientation: portrait)
  and (-webkit-min-device-pixel-ratio: 1.5) {
    .aling-btn {
        left: -6px;
    }
}

@media (min-width: 1281px) {
    .game-cover {
        width: 108px !important;
        margin: 6px 25.8px !important;

        img {
            height: 144px !important;
        }
    }
}

</style>
